import { useLocation } from 'react-router-dom';

export default function useRouterSearchParams(): URLSearchParams {
	return new URLSearchParams(useLocation().search);
}
